// The Projects table's Display as Inventory choice. Deliberately browser-local rather than a
// server-side user preference: the mode is not meant to follow the user across devices, unlike
// the column and saved-view choices on the same page.
const STORAGE_KEY = 'projectsDisplayAsInventory';

export const getDisplayAsInventory = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const persistDisplayAsInventory = (enabled: boolean): void => {
  try {
    localStorage.setItem(STORAGE_KEY, String(enabled));
  } catch {
    // Ignore write failures (storage disabled or over quota) — the mode still applies for this session.
  }
};
